module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-返回-亮.e55e8.png";